import type { Pixel } from '@adtrackify/at-tracking-event-types';
import { create, type StoreApi, type UseBoundStore } from 'zustand';

import { AccountStorage } from '@/features/workspace/api/account-storage/account-storage';

import type { PixelStore, PixelStoreState } from '../types/create-pixel-store-types';

const initialState: PixelStoreState = {
  currentPixel: null,
  pixelId: null,
  destinations: [],
};

export function createPixelStore(accountId: string): UseBoundStore<StoreApi<PixelStore>> {
  const stored = AccountStorage.get(accountId, 'pixel');
  const initial: PixelStoreState = {
    currentPixel: stored?.currentPixel ?? null,
    pixelId: stored?.pixelId ?? null,
    destinations: [], // Always empty - destinations are in React Query
  };

  return create<PixelStore>()((set, get) => ({
    ...initial,

    setCurrentPixel: (pixel: Pixel) => {
      set({ currentPixel: pixel, pixelId: pixel.id });
      AccountStorage.set(accountId, 'pixel', {
        currentPixel: pixel,
        pixelId: pixel.id,
      });
    },

    setPixelId: (id: string) => {
      set({ pixelId: id });
      AccountStorage.set(accountId, 'pixel', {
        currentPixel: get().currentPixel,
        pixelId: id,
      });
    },

    // No-op: destinations are managed by React Query
    setDestinations: () => {},

    reset: () => {
      set(initialState);
      AccountStorage.remove(accountId, 'pixel');
    },
  }));
}
